import { Helmet } from "react-helmet";
import React from "react";
import "./Blog.css"; // Assuming you'll add your styles in this separate file

const Blog = () => {
  return (
    <>
      <Helmet>
        <title>
          Interior Design Tips & Trends | Blog by [Your Company Name]
        </title>
        <meta
          name="description"
          content="Stay updated with the latest interior design tips, trends, and expert advice. Explore our blog for inspiration on home, office, and commercial designs."
        />
        <meta
          name="keywords"
          content="interior design blog, home design tips, office design advice, interior design trends, home decor ideas, commercial interior design"
        />
      </Helmet>
      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col-xl-6 mb-2">
            <div className="card custom-card">
              <img
                className="card-img-top img-fluid"
                src="/images/kitchen.png"
                alt="Card image cap"
              />
              <div className="card-body">
                <h5 className="card-title">
                  How To Plan Your Kitchen Interior Design
                </h5>
                <p className="card-text">
                  Designing your kitchen is more than just choosing the right
                  color for your walls and cabinets. It involves careful
                  planning of space, functionality, and aesthetics to create a
                  kitchen that suits your needs and lifestyle.
                </p>
              </div>
              <div className="card-body">Elson_m August 8, 2024</div>
            </div>
          </div>

          <div className="col-xl-6 mb-2">
            <div className="card custom-card">
              <img
                className="card-img-top img-fluid"
                src="/images/bedroom.png"
                alt="Card image cap"
              />
              <div className="card-body">
                <h5 className="card-title">
                  How To Plan Your Bedroom Interior Design
                </h5>
                <p className="card-text">
                  Designing your Bedroom is more than just choosing the right
                  color for your walls and cabinets. It involves careful
                  planning of space, functionality, and aesthetics to create a
                  kitchen that suits your needs and lifestyle.
                </p>
              </div>
              <div className="card-body">Anushka Kholi August 15, 2024</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
